var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWebsitePublish = function SvgWebsitePublish(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 27,
    viewBox: "0 0 32 27",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4546 19.1842V26.2895H14.5455V19.1842H17.4546Z",
    fill: "#7EAAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00003 25.579C8.00003 24.7942 8.65125 24.158 9.45458 24.158H22.5455C23.3488 24.158 24 24.7942 24 25.579C24 26.3638 23.3488 27.0001 22.5455 27.0001H9.45458C8.65125 27.0001 8.00003 26.3638 8.00003 25.579Z",
    fill: "#7EAAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.55263C0 1.59057 1.62806 0 3.63636 0H28.3636C30.3719 0 32 1.59057 32 3.55263V17.7632C32 19.7252 30.3719 21.3158 28.3636 21.3158H3.63636C1.62805 21.3158 0 19.7252 0 17.7632V3.55263ZM3.63636 2.84211C3.2347 2.84211 2.90909 3.16022 2.90909 3.55263V17.7632C2.90909 18.1556 3.2347 18.4737 3.63636 18.4737H28.3636C28.7653 18.4737 29.0909 18.1556 29.0909 17.7632V3.55263C29.0909 3.16022 28.7653 2.84211 28.3636 2.84211H3.63636Z",
    fill: "#7EAAFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11L20 11",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8441 15L21 10.8442",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8441 6.68823L21 10.8441",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWebsitePublish, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/website-publish.44dddab5.svg";
export { ForwardRef as ReactComponent };